// extracted by mini-css-extract-plugin
export default {"productDescription":"Iaa-z","featuredDescription":"Jaa-z","description":"Kaa-z","more":"Laa-z","descriptionSku":"Maa-z"};